module.exports = __webpack_public_path__ + "src/assets/img/bg3.9aa448ce.jpg";